import React, { useState } from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";

import { TableRow, TableCell, Box, Button } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import { Delete } from "@material-ui/icons";
import CustomDialog from "@jumbo/Dashboards/AccessList/CustomDialog";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import MarathonRequests from "services/marathon";
import moment from "moment-jalaali";


const useStyles = makeStyles((theme) => ({
  tableRowRoot: {
    position: "relative",
    transition: "all .2s",
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    "&:hover, &.active": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      "& $tableCellRoot, & $titleRoot": {
        color: theme.palette.text.primary,
      },
    },
    "&:last-child": {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: `0 3px 10px 0 ${alpha(theme.palette.common.dark, 0.2)}`,
      borderTopColor: "transparent",
    },
    "&.collapse-table-row": {
      borderTop: "0 none",
      "& $tableCellRoot": {
        padding: 0,
      },
    },
    "&.active": {
      borderTop: "0 none",
      "&:hover": {
        transform: "none",
        boxShadow: "none",
      },
    },
  },
  tableCellRoot: {
    padding: 6,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.text.secondary,
    borderBottom: "0 none",
    position: "relative",
    "&:first-child": {
      paddingLeft: 24,
    },
    "&:last-child": {
      textAlign: "right",
      paddingRight: 24,
    },
  },
  titleRoot: {
    color: theme.palette.text.secondary,
    letterSpacing: 0.25,
  },
  createIconContainer: {
    background: "transparent",
    color: theme.palette.secondary.main,
    width: "35px",
    height: "35px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    cursor: "pointer",
  },
  tableActionContainer: {
    direction: "rtl",
  },
}));

const MarathonTicketListTableItem = ({ user, id, quizId, date }) => {
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [openRemoveAnswersDialog, setOpenRemoveAnswersDialog] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { marathonTicketList, marathonTicketListCurrentPage } = useSelector(
    ({ tests }) => tests
  );

  const handleDeleteTicket = () => {
    setOpenRemoveDialog(false);
    dispatch(
      MarathonRequests.removeMarathonTicketById(
        id,
        marathonTicketList.length,
        marathonTicketListCurrentPage,
        quizId
      )
    );
  };

  const handleRemoveAnswers = () => {
    setOpenRemoveAnswersDialog(false);
    dispatch(MarathonRequests.batchRemoveAnswers(id));
  };

  return (
    <React.Fragment>
      <TableRow className={clsx(classes.tableRowRoot)}>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {user.personnelCode}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {user.nationalCode}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {user.fullName}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {user.phone}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {moment(date).format("HH:mm:ss jYYYY/jMM/jDD")}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableActionContainer)}
        >
          <Box display={"flex"}>
            <Box
              className={classes.createIconContainer}
              onClick={() => setOpenRemoveDialog(true)}
            >
              <Delete />
            </Box>
            <Button
              variant="outlined"
              color="secondary"
              style={{ marginLeft: 10 }}
              onClick={() => setOpenRemoveAnswersDialog(true)}
            >
              حذف پاسخ‌ها
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginLeft: "10px" }}
              onClick={() =>
                history.push(`/marathonAnswer/${user._id}/${quizId}`)
              }
            >
              پاسخ
            </Button>
          </Box>
        </TableCell>
      </TableRow>
      <CustomDialog
        text={"آیا از حذف دسترسی این مورد اطمینان دارید؟"}
        open={openRemoveDialog}
        handleClose={() => setOpenRemoveDialog(false)}
        action={handleDeleteTicket}
      />
      <CustomDialog
        text={"آیا از حذف تمام پاسخ‌های این شرکت‌کننده مطمئن هستید؟"}
        open={openRemoveAnswersDialog}
        handleClose={() => setOpenRemoveAnswersDialog(false)}
        action={handleRemoveAnswers}
      />
    </React.Fragment>
  );
};

export default MarathonTicketListTableItem;
